window.onload = function () {

};

// ページの読み込みと解析が完了した後に有効になる処理を記述
window.addEventListener('DOMContentLoaded', function (e) {

});
